import React, { useEffect } from "react";
import { Github, Twitter, Instagram, Mail } from "lucide-react";
import { fetchBasicConfig } from "../../slice/configSlice";
import { useDispatch, useSelector } from "react-redux";
import { Facebook, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const dispatch = useDispatch();
  const { basicConfig } = useSelector((state) => state.configs);
  useEffect(() => {
    dispatch(fetchBasicConfig());
  }, []);

  return (
    <footer className="bg-gray-900 text-gray-300 py-8">
      <div className="container mx-auto px-4 ">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row justify-between gap-8 ">
          {/* Company Info */}
          <div className="flex flex-col space-y-4 w-1/3 ">
            <div className="flex items-center space-x-2">
              <img
                src={basicConfig?.logo}
                alt="Company Logo"
                className="h-10 md:h-20 w-10 md:w-20 "
              />
              <h3>VERDICAL</h3>
            </div>
            <p className="text-gray-400">
              With truthfulness embedded in the meaning of our name, it is an
              attribute that is reflective of the integrity that Verdical
              Solutions is recognized for. Present in business with all
              categories of industries we lead in facilitating the Rewards and
              Corporate Gifting requirements of several established
              organizations who have consistently worked with us and continue to
              build their relations in business with us.
            </p>

            <p>© {currentYear} Verdical Solutions. All rights reserved.</p>
          </div>

          <div className="  w-1/3 flex flex-col items-center pt-4  ">
            <div className="flex space-y-4 flex-col justify-center sm:justify-end text-gray-300">
              <h4>Contact Us</h4>
              <p>
                Address : B 12,13, Kiran Garden, Matiyala Road, Uttam Nagar, New
                Delhi - 110059
              </p>

              <p>
                <span className="font-bold">For Customer Support:</span>{" "}
                <a href="mailto: info@verdical.in"> info@verdical.in</a>{" "}
              </p>

              <div className="flex space-x-4 pt-2 items-center">
                <a
                  href="https://www.linkedin.com/company/verdical-solutions/"
                  className="hover:text-white transition-colors duration-300"
                >
                  <LinkedIn
                    size={20}
                    className="hover:scale-110 transition-transform"
                  />
                </a>
                <a
                  href="https://www.instagram.com/verdical.solutions/"
                  className="hover:text-white transition-colors duration-300"
                >
                  <Instagram
                    size={20}
                    className="hover:scale-110 transition-transform"
                  />
                </a>
                <a
                  href="https://www.facebook.com/people/Verdical-Solutions-India-Pvt-Ltd/61553250158114/"
                  className="hover:text-white transition-colors duration-300"
                >
                  <Facebook
                    size={20}
                    className="hover:scale-110 transition-transform"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="  w-1/5 pt-4 ">
            <div className="flex space-y-4 flex-col justify-center sm:justify-end text-gray-300">
              <h4>Quick Links</h4>
              <a
                href="/privacy-policy"
                className="hover:text-white transition-colors duration-300 no-underline"
              >
                Privacy Policy
              </a>
              <a
                href="/terms-conditions"
                className="hover:text-white transition-colors duration-300 no-underline"
              >
                Terms of Service
              </a>
              <a
                href="/shipping-policy"
                className="hover:text-white transition-colors duration-300 no-underline"
              >
                Shipping Policy
              </a>
              <a
                href="/cancellation-policy"
                className="hover:text-white transition-colors duration-300 no-underline"
              >
                Cancellation and Refund Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
